<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>La Matanza de Cholula. 1519</h2>
    <img @click="imageClicked(0)" src="galerias/tenochtitlan/g4/g4.jpg" class="mainphoto"/>
    <p class='photo-description'>Portada del texto: la matanza de Cholula o sangre y fuego, fuego y sangre. Ilustrado por José Guadalupe Posada, Impresión litográfica, 1900. Casa editorial Maucci Hermanos. Barcelona-México.</p>
    <p>La gran ciudad sagrada de Cholula sorprendió gratamente a Cortés a su llegada, entre el 11 y 12 de octubre de 1520, por lo que pensó que era un buen lugar para que los españoles llegados a este territorio pudieran vivir. Incluso los gobernantes Cholultecas, dieron un buen recibimiento a Cortés y a los ejércitos indígenas aliados, aunque se pidió que los tlaxcaltecas estuvieran fuera de la ciudad por la rivalidad que había entre estos dos pueblos.</p>
    <p>Sin embargo, entre el 16 y 18 de octubre ocurrió uno de los hechos más terribles de la conquista: la matanza de Cholula. En este cruel ataque, los aliados tlaxcaltecas, cempoaltecas y españoles atacaron a los Cholultecas que no esperaban una acción de este tipo. Aún no quedan claras las causas, no se sabe si fue emboscada contra Cortés o una venganza Tlaxcalteca contra los Cholultecas, lo cierto es que, esta matanza fue una muestra del poder de las alianzas militares que había construido Cortés.</p>
    <p>En la segunda carta de relación, Hernán Cortés describió a Cholula con las siguientes palabras: “Esta ciudad es muy fértil de labranzas porque tiene mucha tierra y se riega la más parte de ella y aun es la ciudad más hermosa de fuera que hay en España, porque es muy torreada y llana y certifico a vuestra alteza que yo conté desde una mezquita cuatrocientas treinta tantas torres en la dicha ciudad y todas son de mezquitas. Es la ciudad más a propósito de vivir españoles que yo he visto de los puertos acá”</p>
    <h5>VER MÁS</h5>
    <p>Aquí puedes leer completo este pequeño libro: 
      <ul>
        <li><a target="_blank" href='https://inehrm.gob.mx/recursos/BibliotecaBicentenario/JovenesYNinios/LA%20MATANZA%20DE%20CHOLULA.pdf'>inehrm.gob.mx</a></li>
      </ul>
    </p>
    <h4>La Cholula Prehispánica y el Tlachihualtepetl</h4>
    <img @click="imageClicked(1)" src="galerias/tenochtitlan/g4/G4_a.jpg" class="mainphoto"/>
    <p class='photo-description'>Imagen tomada del libro: “Historia Tolteca-Chichimeca”. Manuscrito. Col. Biblioteca Nacional de Francia</p>
    <p>Cholula fue una importante ciudad mesoamericana, su historia se remonta aproximadamente al año 200 a.C. Gracias a su ubicación fue un importante centro de comercio y un punto de encuentro para diferentes culturas.</p>
    <p>La Gran Pirámide de Cholula o “Tlachihualtepetl”, como se le conocía antes de la llegada de los españoles, es un templo dedicado a Tláloc, tiene la mayor superficie en Mesoamérica con 450 metros por lado, su construcción aprovechó una elevación natural para ir sobreponiendo construcciones en diferentes etapas a lo largo del tiempo.</p>
    <p>Si quieres saber más de la historia de Cholula 
      <ul>
        <li><a target="_blank" href='https://mediateca.inah.gob.mx/repositorio/islandora/object/articulo%3A20332'>mediateca.inah.gob.mx</a></li>
      </ul>
    </p>
    <h4>La Ciudad Sagrada</h4>
    <img @click="imageClicked(2)" src="galerias/tenochtitlan/g4/G4_4.jpg" class="mainphoto"/>
    <p class='photo-description'>Imagen tomada del libro: “Historia Tolteca-Chichimeca”. Manuscrito. Col. Biblioteca Nacional de Francia</p>
    <p>En la Relación geográfica de Cholula se dice que los gobernantes de otras tierras llegaban a Cholula a “ reconocer obediencia al ídolo della, Quetzalcoatl, al cual ofrecía plumas ricas, mantas, oro y piedras preciosas y otras cosas de valor”. Además, describen el ritual que se realizaba en este lugar para confirmar su posición de poder: “horadándoles las orejas, narices o el labio inferior, según el señorío que tenían, con lo cual quedaban confirmados en sus señoríos y se volvían a sus tierra”.</p>
    <p>Para conocer el documento completo, visita: 
      <ul>
        <li><a target="_blank" href='https://gallica.bnf.fr/ark:/12148/btv1b84559448/f6.item'>gallica.bnf.fr</a></li>
      </ul>
    </p>
  </div>
</template>

<script>
export default {
  name: "Sala1m4",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    }
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
